import { escapeRegExp } from "utils/escape-regex-search-string";

/**
 * Treat queries that start with `@` as WhatsApp username searches.
 */
export const isWAUsernameSearchTerm = (term: string) => {
  return term.trim().startsWith("@");
};

export const normalizeWAUsernameSearchTerm = (term: string) => {
  return term.trim().replace(/^@+/, "").trim();
};

/** Contact collection: match Cloud Native connection username. */
export const buildContactWAUsernameSearchQuery = (term: string) => {
  const username = normalizeWAUsernameSearchTerm(term);
  if (!username) {
    return undefined;
  }
  return {
    "metaData.connections": {
      $elemMatch: {
        type: "WHATS_APP_CLOUD_NATIVE",
        "data.waUsername": {
          $regex: escapeRegExp(username),
          $options: "i",
        },
      },
    },
  };
};

/** Conversation collection: match embedded contact Cloud Native username. */
export const buildConversationWAUsernameSearchQuery = (term: string) => {
  const username = normalizeWAUsernameSearchTerm(term);
  if (!username) {
    return undefined;
  }
  return {
    "contact.metaData.connections": {
      $elemMatch: {
        type: "WHATS_APP_CLOUD_NATIVE",
        "data.waUsername": {
          $regex: escapeRegExp(username),
          $options: "i",
        },
      },
    },
  };
};
